import { render, staticRenderFns } from "./TabExpediente.vue?vue&type=template&id=2a517828"
import script from "./TabExpediente.vue?vue&type=script&lang=js"
export * from "./TabExpediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a517828')) {
      api.createRecord('2a517828', component.options)
    } else {
      api.reload('2a517828', component.options)
    }
    module.hot.accept("./TabExpediente.vue?vue&type=template&id=2a517828", function () {
      api.rerender('2a517828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/constitucionsociedades/TabExpediente.vue"
export default component.exports